import { AxiosResponse } from "axios";
import { IConfigCSVErrors } from "domain/Config/Models/IConfigCSVErrors";
import { IInventoryPositionResponse } from "domain/Inventory/Models/IInventoryPositionResponse";
import { IComposedFilter } from "domain/Utils";
import { useRequest } from "hooks/useRequest";
import i18n from "i18n";

const buildFilterBody = (filter?: IComposedFilter) => ({
	categories: filter?.filter?.filter(c => c.type === "category").map(c => ({ id: c.id, name: c.name })) ?? [],
	stores:     filter?.filter?.filter(c => c.type === "store").map(c => ({ id: c.id, name: c.name })) ?? [],
	products:   filter?.filter?.filter(c => c.type === "product").map(c => ({ id: c.id, name: c.name })) ?? [],
	tags:       filter?.filter?.filter(c => c.type === "tag").map(c => c.name) ?? [],
});

export const useInventoryPositionRequester = () => {
	const request = useRequest("Inventories");

	return {
		getAll: (skip = 0, take = 100, filter?: IComposedFilter) => {
			const params = new URLSearchParams();
			params.append("skip", skip.toString());
			params.append("take", take.toString());

			return request
				.POST(`?${params.toString()}`, buildFilterBody(filter))
				.then(
					(res: AxiosResponse<IInventoryPositionResponse[]>) =>
						res.data,
				);
		},
		getCount: (filter?: IComposedFilter) =>
			request
				.POST(`count`, buildFilterBody(filter))
				.then((res: AxiosResponse<number>) => res.data),
		importCSV: (file: File) => {
			const formData = new FormData();
			formData.append("file", file);

			return request.POST(`validateCSV/${i18n.language}`, formData).then(
				(
					res: AxiosResponse<{
						item1: string;
						item2: IConfigCSVErrors[];
					}>,
				) => ({
					guid: res.data.item1,
					errors: res.data.item2,
				}),
			);
		},
		saveCSV: (guid: string) => {
			return request
				.POST(`saveCSV/${guid}`, {})
				.then((res: AxiosResponse<IConfigCSVErrors[]>) => res.data);
		},
	};
};
